import script from "./svc-uscrg-rqst-dp.vue?vue&type=script&setup=true&lang=js"
export * from "./svc-uscrg-rqst-dp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__